const dynamicScripts = [
  'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
];

export class StaticPageJSHelper {
  public static loadScript() {
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  public static PaypalButtonScript(){
    const node = document.createElement('script');
    node.innerHTML = `  	
    PayPal.Donation.Button({
          env: "production",
          hosted_button_id: "4XJS4B4CTPUCA",
          image: {
            src: "https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif",
            alt: "Donate with PayPal button",
            title: "PayPal - The safer, easier way to pay online!",
          },
        }).render("#donate-button");`;
    node.type = 'text/javascript';
    node.async = false;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
   
  }
}
